import {
  Icon,
  IconButton,
  Spacer,
  SvgArrowRight,
  SvgFolder,
  Text,
} from '@loomhq/lens';
import _indexOf from 'lodash/indexOf';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { updateFolderToMoveTo } from 'actions/moveModal';

import './styles.less';

const PADDING_LEFT = 24;

const GridCell = class extends Component {
  render() {
    const {
      closeFolder,
      checkedFolderIds,
      doNotRecurse,
      folder,
      folderToMoveTo,
      generateChildren,
      level,
      openedFolderIds,
      openFolder,
    } = this.props;

    const { id, name, local_id: localId } = folder;
    const hasChildren = folder.hasSubFolders;
    const isChecked = _indexOf(checkedFolderIds, id) > -1;
    const isSelected =
      localId != null
        ? folderToMoveTo.local_id === localId
        : folderToMoveTo.id === id;
    const isOpened = _indexOf(openedFolderIds, id) > -1;
    const controlIconColor = isSelected ? 'white' : 'body';

    if (isChecked) {
      return null;
    }

    let controlIcon = <IconButton isDisabled />;
    let childGridCells;

    if (hasChildren && isOpened && !doNotRecurse) {
      controlIcon = (
        <div className="chevronDown">
          <IconButton
            icon={<SvgArrowRight />}
            onClick={e => closeFolder(e, id)}
            iconColor={controlIconColor}
          />
        </div>
      );

      childGridCells = generateChildren(folder.id, checkedFolderIds, level + 1);
    } else if (hasChildren && !isOpened && !doNotRecurse) {
      controlIcon = (
        <div>
          <IconButton
            icon={<SvgArrowRight />}
            onClick={e => openFolder(e, id)}
            iconColor={controlIconColor}
          />
        </div>
      );
    }

    const style = {
      paddingLeft: `${PADDING_LEFT * (level - 1)}px`,
    };

    return (
      <div className={`${level === 1 ? 'top-level-cell' : ''}`} key={id}>
        <div
          className={`grid-cell ${isSelected ? 'selected' : ''}`}
          onClick={this.select.bind(this, folder)}
          style={style}
        >
          {controlIcon}
          <Spacer left={1} right={2}>
            <Icon
              icon={<SvgFolder />}
              color={isSelected ? 'white' : undefined}
            />
          </Spacer>
          <Text hasEllipsis={true}>{name}</Text>
        </div>
        {childGridCells}
      </div>
    );
  }

  select(folder) {
    const { folderToMoveTo } = this.props;

    if (folderToMoveTo.id === folder.id) {
      return;
    }

    this.props.updateFolderToMoveTo(folder);
  }
};

const mapStateToProps = state => {
  const { folderToMoveTo } = state.moveModal;

  return { folderToMoveTo };
};

const mapDispatchToProps = dispatch => {
  return {
    updateFolderToMoveTo: folder => dispatch(updateFolderToMoveTo(folder)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GridCell);
